import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { collection, getDocs, addDoc } from "firebase/firestore/lite";
import db from "../../firebase";
import {
  Typography,
  TextField,
  Stack,
  Button,
  Alert,
  SelectChangeEvent,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

interface activitatDB {
  id?: string;
  title?: string;
  desc?: string;
  price?: string;
  image?: string;
  docs?: Array<string>;
  contact?: {
    whats?: string;
    tel?: string;
    email?: string;
    link?: string;
  };
  address?: string;
  category?: string;
  subcategory?: string;
  // parroquia?: string;
  // Per a qui: Sol / Parella / Amics / Família / Nens
  // Compartir
  // Disponibilitat: Tot l'any / Temporada específica
  // Durada: <1h / 1-3h / 3-6h / Tot el dia
  // Dificultat: Fàcil / Moderat / Difícil / Expert???
  // Tipus activitat: interior/exterior
}

// Tipus de dades per a categories
interface CategoriesData {
  [category: string]: string[];
}

export const ActivitatsCreationPage = () => {
  const [categoriesData, setCategoriesData] = useState<CategoriesData>({});
  const [loading, setLoading] = useState(true);
  const [activity, setActivity] = useState({} as activitatDB);
  const [openDialog, setOpenDialog] = useState(false);

  console.log("categories");
  console.log(categoriesData);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "categories"));
        const data: CategoriesData = {};

        querySnapshot.forEach((doc) => {
          console.log(doc.data());
          setCategoriesData(doc.data());
        });
      } catch (error) {
        console.error("Error carregant categories:", error);
      } finally {
        setLoading(false);
      }
    };

    getCategories();
  }, []);

  function handleFormChange(newValue: string | null, prop: string) {
    if (prop !== undefined) {
      if (prop === "address") {
        setActivity((prevState) => ({
          ...prevState,
          address: newValue as string,
        }));
      } else if (
        prop === "whats" ||
        prop === "tel" ||
        prop === "email" ||
        prop === "link"
      ) {
        setActivity((prevState) => ({
          ...prevState,
          contact: {
            ...prevState.contact!,
            [prop]: newValue,
          },
        }));
      } else {
        setActivity({ ...activity, [prop]: newValue });
      }
    }
  }

  const handleCategoryChange = (event: SelectChangeEvent) => {
    const newCategory = event.target.value;
    setActivity((prevState) => ({
      ...prevState,
      category: newCategory as string,
      subcategory: "", // reiniciem la subcategoria
    }));
  };

  const handleSubcategoryChange = (event: SelectChangeEvent) => {
    setActivity((prevState) => ({
      ...prevState,
      subcategory: event.target.value,
    }));
  };

  const handleClose = () => {
    window.location.reload();
  };

  const handleReuse = () => {
    console.log(activity);
    // setActivity({} as activitatDB);
    setOpenDialog(false);
  };

  async function saveActivity(_event: React.MouseEvent<HTMLElement>) {
    console.log(activity);
    if (activity.title !== undefined && activity.title !== "") {
      try {
        await addDoc(collection(db, "activitats"), activity).then(function (
          activityDoc
        ) {
          console.log("Activitat creada");
          setOpenDialog(true);
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Helmet>
        <meta content="noindex" name="robots" />
      </Helmet>

      <Grid container>
        <Grid xs={12} sm={10} smOffset={1} sx={{ m: 2 }}>
          <TextField
            fullWidth
            label="Title"
            value={activity.title}
            onChange={(e) => handleFormChange(e.target.value, "title")}
          />
        </Grid>
        <Grid xs={12} sm={5} smOffset={1} sx={{ m: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Categoria</InputLabel>
            <Select
              value={activity.category || ""}
              label="Categoria"
              onChange={handleCategoryChange}
            >
              {Object.keys(categoriesData).map((category) => (
                <MenuItem key={category} value={category}>
                  {category}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {activity.category !== undefined && (
          <Grid xs={12} sm={5} smOffset={1} sx={{ m: 2 }}>
            {/* Dropdown de subcategoria */}
            <FormControl fullWidth disabled={!activity.category}>
              <InputLabel>Subcategoria</InputLabel>
              <Select
                value={activity.subcategory || ""}
                label="Subcategoria"
                onChange={handleSubcategoryChange}
                disabled={!activity.category}
              >
                {categoriesData[activity.category!].map((sub) => (
                  <MenuItem key={sub} value={sub}>
                    {sub}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        <Grid xs={12} sm={10} smOffset={1} sx={{ m: 2 }}>
          <Alert severity="error">
            Si gratüit deixar en blanc o posar 0, si preu posar número, sin
            escriure algo. MAI SÍMBOL €!!!.
          </Alert>
          <TextField
            fullWidth
            label="Price"
            value={activity.price}
            onChange={(e) => handleFormChange(e.target.value, "price")}
          />
        </Grid>
        <Grid xs={12} smOffset={1} sx={{ m: 2 }}>
          <TextField
            label="Desc"
            multiline
            fullWidth
            value={activity.desc}
            onChange={(e) => handleFormChange(e.target.value, "desc")}
          />
        </Grid>
        {activity.desc !== undefined && (
          <Grid xs={12} smOffset={1} sx={{ m: 2 }}>
            <Card sx={{ bgcolor: "warning.light" }}>
              <CardContent>
                <Typography sx={{ whiteSpace: "pre-wrap" }}>
                  {activity.desc.replace(/\\n/g, "\n\n")}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}
        <Grid xs={12} sm smOffset={1} sx={{ m: 2 }}>
          <TextField
            label="Image"
            fullWidth
            value={activity.image}
            onChange={(e) => handleFormChange(e.target.value, "image")}
          />
        </Grid>
        <Grid xs={12} sm sx={{ m: 2 }}>
          <img src={activity.image} width="100%" alt="event image" />
        </Grid>
        <Grid xs={12} sm={10} smOffset={1} sx={{ m: 2 }}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            spacing={2}
          >
            <Grid xs={12} sm={6} md>
              <Stack direction="column" spacing={1}>
                <Alert severity="error">Posar 376 SEMPRE!!!</Alert>
                <TextField
                  fullWidth
                  label="Whatsapp"
                  value={activity.contact?.whats || ""}
                  onChange={(e) => handleFormChange(e.target.value, "whats")}
                />
              </Stack>
            </Grid>
            <Grid xs={12} sm={6} md>
              <TextField
                fullWidth
                label="Tel"
                value={activity.contact?.tel || ""}
                onChange={(e) => handleFormChange(e.target.value, "tel")}
              />
            </Grid>
            <Grid xs={12} sm={6} md>
              <TextField
                fullWidth
                label="Email"
                value={activity.contact?.email || ""}
                onChange={(e) => handleFormChange(e.target.value, "email")}
              />
            </Grid>
            {/* {Do we need link in here???} */}
            <Grid xs={12} sm={6} md>
              <TextField
                fullWidth
                label="Link"
                value={activity.contact?.link || ""}
                onChange={(e) => handleFormChange(e.target.value, "link")}
              />
            </Grid>
            <Grid xs={12} sm={6} md>
              <TextField
                fullWidth
                label="Address"
                value={activity.address || ""}
                onChange={(e) => handleFormChange(e.target.value, "address")}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={12} sm={10} smOffset={1} sx={{ m: 2 }}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid xs>
              <Button
                onClick={(e) => saveActivity(e)}
                fullWidth
                variant="contained"
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Dialog open={openDialog} onClose={handleClose}>
        <DialogTitle>Activitat creada</DialogTitle>
        <DialogContent>
          <Typography id="alert-dialog-description">
            Activitat creada!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Deixa camps en blanc</Button>
          <Button onClick={handleReuse}>Reutilitzar info</Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};
